import { useMemo } from 'react'
import Badges from 'core/elements/badge/Badges'
import Text from 'core/elements/Text'
import useClusterAccessTenants from './useClusterAccessTenants'

// See ClusterAccessCell.spec.md for CAC-FR-001 through CAC-FR-003
interface Props {
  item?: { name: string; tenants?: string[] }
  containerType?: 'table' | 'panel'
  maxBadgesVisible?: number
}

const EMPTY_TENANT_IDS: string[] = []

export default function ClusterAccessCell({
  item,
  containerType = 'table',
  maxBadgesVisible = 6,
}: Props) {
  const tenantIds = item?.tenants ?? EMPTY_TENANT_IDS

  const { loading, tenantsById: tenantsByIdMap } = useClusterAccessTenants()

  const badgeValues = useMemo(
    () =>
      tenantIds.map((tenantId) => {
        const tenant = tenantsByIdMap[tenantId]
        return tenant
          ? {
              text: tenant.name,
              tooltipText: tenant.domain ? `${tenant.name} (${tenant.domain})` : tenant.name,
            }
          : { text: tenantId, tooltipText: tenantId }
      }),
    [tenantIds, tenantsByIdMap],
  )

  if (tenantIds.length === 0) {
    return <Text variant="body2">All</Text>
  }

  if (loading) {
    return <Text variant="body2">Loading…</Text>
  }

  return (
    <Badges
      values={badgeValues}
      maxVisible={maxBadgesVisible}
      entityType="string"
      containerType={containerType}
      showCopy={false}
      useTooltipTextInOverflow
    />
  )
}
